export default __webpack_public_path__ + "static/media/loss-analysis-label-icon.f6929cf0.svg";